<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Kategori</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Master / Data Kategori </span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button icon="pi pi-plus" label="Kategori" @click="onAddData" />
      </div>
      <fx-table
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        :filters="filters"
        @request="onRequestData"
      >
        <template #columns>
          <Column
            field="ctg"
            header="Kode Kategori"
            style="min-width: 12rem"
            sortable
            :filter-match-mode-options="equalModesOption"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="name"
            header="Nama Kategori"
            style="min-width: 15rem"
            sortable
            :filter-match-mode-options="containModesOption"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="div"
            header="Divisi"
            style="min-width: 12rem"
            filterField="div_id"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <AutoComplete
                v-model="selectedDivisi"
                placeholder="Search"
                :suggestions="listDivisi"
                field="name"
                class="w-full"
                :showClear="true"
                input-class="w-full"
                @complete="searchDivisi"
                @item-select="onSelectDivisi(filterModel, filterCallback)"
              >
                <template v-if="selectedDivisi" #selected-item>
                  {{ selectedDivisi.name }}
                </template>
              </AutoComplete>
            </template>
          </Column>
          <Column
            field="dept"
            header="Departemen"
            filterField="dept_id"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <AutoComplete
                v-model="selectedDepartemen"
                placeholder="Search"
                :suggestions="listDepartemen"
                field="name"
                class="w-full"
                :showClear="true"
                input-class="w-full"
                @complete="searchDepartemen"
                @item-select="onSelectDepartemen(filterModel, filterCallback)"
              >
                <template v-if="selectedDepartemen" #selected-item>
                  {{ selectedDepartemen.name }}
                </template>
              </AutoComplete>
            </template>
          </Column>
          <Column
            field="subdept"
            filterField="subdept_id"
            header="Sub Departemen"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <AutoComplete
                v-model="selectedSubDepartemen"
                placeholder="Search"
                :suggestions="listSubDepartemen"
                field="name"
                class="w-full"
                :showClear="true"
                input-class="w-full"
                @complete="searchSubDepartemen"
                @item-select="
                  onSelectSubDepartemen(filterModel, filterCallback)
                "
              >
                <template v-if="selectedSubDepartemen" #selected-item>
                  {{ selectedSubDepartemen.name }}
                </template>
              </AutoComplete>
            </template>
          </Column>
          <Column
            field="std_mrg"
            header="Std Margin"
            style="min-width: 8rem; justify-content: flex-end"
          >
            <template #body="{ data }"> {{ data.std_mrg }}% </template>
          </Column>
          <Column style="flex-grow: 1; justify-content: flex-end">
            <template #body="{ data }">
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onEditData(data)"
              />
              <Button
                type="button"
                icon="pi pi-trash"
                class="p-button-outlined p-button-danger p-button-text"
                @click="onConfirmDeletion(data)"
              />
            </template>
          </Column>
        </template>
      </fx-table>
    </div>
    <Dialog
      :header="form && form.id > 0 ? 'Edit kategori' : 'Tambah kategori'"
      v-model:visible="dialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      :maximizable="true"
    >
      <form-kategori
        :item="form"
        :loading="isLoadingSave"
        :editMode="editMode"
        @save="onSaveData"
      />
    </Dialog>
    <Dialog
      header="Hapus Kategori"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Kategori <strong>{{ form.nama }}</strong> akan dihapus. Proses
          ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeleteKategori"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import DivisiService from '@/services/DivisiService'
import DepartemenService from '@/services/DepartemenService'
import SubDepartemenService from '@/services/SubDepartemenService'
import KategoriService from '@/services/KategoriService'
import FormKategori from '@/components/master/FormKategori'
import FxTable from '@/components/FxTable'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'Kategori',
  components: {
    FormKategori,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      subdept_id: 0,
      dept_id: 0,
      div_id: 0,
      divisiService: null,
      departemenService: null,
      subdepartemenService: null,
      kategoriService: null,
      dialog: false,
      dialogHapus: false,
      isLoading: false,
      isLoadingSave: false,
      editMode: false,
      selectedDivisi: null,
      selectedDepartemen: null,
      selectedSubDepartemen: null,
      listDivisi: [],
      listDepartemen: [],
      listSubDepartemen: [],
      items: [],
      item: {},
      form: {
        id: 0,
        div_id: 0,
        dept_id: 0,
        subdept_id: 0,
        div: '',
        dept: '',
        name: null,
        ctg: null,
      },
      kategori: [],
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: '',
        filters: {},
      },
      filters: {
        div_id: { value: null, matchMode: FilterMatchMode.EQUALS },
        dept_id: { value: null, matchMode: FilterMatchMode.EQUALS },
        subdept_id: { value: null, matchMode: FilterMatchMode.EQUALS },
        ctg: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      containModesOption: [
        { label: 'Contains', value: FilterMatchMode.CONTAINS },
      ],
      equalModesOption: [{ label: 'Equals', value: FilterMatchMode.EQUALS }],
    }
  },
  created() {
    this.divisiService = new DivisiService()
    this.departemenService = new DepartemenService()
    this.subdepartemenService = new SubDepartemenService()
    this.kategoriService = new KategoriService()
  },
  async mounted() {
    this.loadData()
  },
  watch: {
    'options.filters'(value) {
      if (!value.div_id.value) {
        this.selectedDivisi = null
      }
      if (!value.dept_id.value) {
        this.selectedDepartemen = null
      }
      if (!value.subdept_id.value) {
        this.selectedSubDepartemen = null
      }
    },
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.loadData()
    },
    async searchDivisi(event) {
      const query = event.query
      await this.divisiService
        .getList(query)
        .then((res) => {
          this.listDivisi = res.data.filter((divisi) =>
            divisi.name.toLowerCase().includes(query.toLowerCase())
          )
        })
        .catch((err) => {
          errorHandler(err, 'Data Divisi', this)
        })
    },
    onSelectDivisi(filterModel, filterCallback) {
      filterModel.value = this.selectedDivisi.id
      filterCallback()
    },
    async searchDepartemen(event) {
      const query = event.query
      const div = this.selectedDivisi ? this.selectedDivisi.id : null
      await this.departemenService
        .getList(div, query)
        .then((res) => {
          this.listDepartemen = res.data.filter((departemen) =>
            departemen.name.toLowerCase().includes(query.toLowerCase())
          )
        })
        .catch((err) => {
          errorHandler(err, 'Data Departemen', this)
        })
    },
    onSelectDepartemen(filterModel, filterCallback) {
      filterModel.value = this.selectedDepartemen.id
      filterCallback()
    },
    async searchSubDepartemen(event) {
      const query = event.query
      const dept = this.selectedDepartemen ? this.selectedDepartemen.id : null
      await this.subdepartemenService
        .getList(dept, query)
        .then((res) => {
          this.listSubDepartemen = res.data.filter((subdepartemen) =>
            subdepartemen.name.toLowerCase().includes(query.toLowerCase())
          )
        })
        .catch((err) => {
          errorHandler(err, 'Data Sub Departemen', this)
        })
    },
    onSelectSubDepartemen(filterModel, filterCallback) {
      filterModel.value = this.selectedSubDepartemen.id
      filterCallback()
    },
    loadData() {
      this.isLoading = true
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.kategoriService
        .paginate(
          page,
          perPage,
          sortField,
          sortOrder,
          this.div_id,
          this.dept_id,
          filters
        )
        .then((res) => {
          this.items = res.data
          this.totalRecords = res.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Kategori', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onEditData(data) {
      this.editMode = true
      this.form.div_id = parseInt(data.div_id, 10)
      this.form.dept_id = parseInt(data.dept_id, 10)
      this.form.subdept_id = parseInt(data.subdept_id, 10)

      this.form.id = data.id
      this.form.parent_ref = data.parent_ref
      this.form.parent_id = data.parent_id
      this.form.ctg = data.ctg
      this.form.name = data.name
      this.form.std_mrg = data.std_mrg
      this.dialog = true
    },

    onAddData() {
      this.editMode = false
      this.form.div_id = 0
      this.form.dept_id = 0
      this.form.subdept_id = 0

      this.form.id = 0
      this.form.parent_id = 0
      this.form.parent_ref = null
      this.form.ctg = null
      this.form.name = null
      this.form.std_mrg = 0
      this.dialog = true
    },
    onSaveData(data) {
      this.isLoadingSave = true
      let item = {}
      item.parent_id = data.parent_id
      item.parent_ref = data.parent_ref
      item.level = 'CAT'
      item.ctg = data.ctg === null ? '' : data.ctg
      item.name = data.name
      item.std_mrg = data.std_mrg

      if (data.id == 0) {
        this.kategoriService
          .add(item)
          .then((res) => {
            if (res.data.status === 1) {
              this.loadData()
              this.$toast.add({
                severity: 'success',
                summary: 'Data kategori',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })
              this.dialog = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Data kategori', this)
          })
          .finally(() => (this.isLoadingSave = false))
      } else {
        this.kategoriService
          .update(data.id, item)
          .then((res) => {
            if (res.data.status === 1) {
              this.loadData()
              this.$toast.add({
                severity: 'success',
                summary: 'Data kategori',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })
              this.dialog = false
            }
          })
          .catch((err) => {
            errorHandler(err, 'Data kategori', this)
          })
          .finally(() => (this.isLoadingSave = false))
      }
    },
    onConfirmDeletion(data) {
      this.form = data
      this.dialogHapus = true
    },
    onDeleteKategori() {
      this.kategoriService
        .delete(this.form.id)
        .then((res) => {
          if (res.status === 1) {
            this.$toast.add({
              severity: 'success',
              summary: 'Data Kategori',
              detail: 'Data berhasil dihapus.',
              life: 3000,
            })
          }
          this.loadData()
        })
        .catch((err) => {
          errorHandler(err, 'Data Kategori', this)
        })
      this.form = {}
      this.dialogHapus = false
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.onAddData()
      }
    },
    /* onToggle(value) {
      this.selectedColumns = this.columns.filter((col) => value.includes(col))
    }, */
  },
}
</script>
